<ng-container *transloco="let t">
    <form [formGroup]="form" class="form">
        <div>
            <tui-input formControlName="name">
                {{ t('receiver_name.label') }}
            </tui-input>
            <tui-error formControlName="name" [error]="[] | tuiFieldError | async"></tui-error>
        </div>

        <div>
            <tui-input-phone-international
                formControlName="phone"
                [countries]="(countries | tuiSortCountries | async) || []"
                [(countryIsoCode)]="countryIsoCode"
            >
                {{ t('your_mobile_phone') }}
            </tui-input-phone-international>
            <p class="text-red-700 mt-2" *ngIf="allowShopDelivery() && turnOffAddress()">{{ t('inform_phone_number') }}</p>
        </div>

        <ng-container *ngIf="(orderType$ | async) === OrderType.Delivery && !(allowShopDelivery() && turnOffAddress())">
            <us-address-input-autocomplete></us-address-input-autocomplete>
        </ng-container>

        <ng-container *ngIf="(orderType$ | async) === OrderType.Pickup">
            <ion-list class="divide-y p-0" lines="none">
                <ion-item class="px-0">
                    <tui-svg slot="start" src="svg::shop-2" class="text-blue-500"></tui-svg>
                    <ion-label>
                        <p>{{ t('store') }}</p>
                        <h4 class="!font-medium" *ngrxLet="shop$ as shop">{{ shop?.address || '-' }}</h4>
                    </ion-label>
                </ion-item>

                <ion-item class="px-0" button (click)="showPickupTimeDialog()">
                    <tui-svg slot="start" src="svg::clock" class="text-orange-500"></tui-svg>
                    <ion-label>
                        <p>{{ t('receiving_time') }}</p>
                        <h4 class="!font-medium" *ngrxLet="bookingTime$ as bookingTime">
                            {{ bookingTime | dfnsFormat : 'p, iiii P' }}
                        </h4>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ng-container>
    </form>

    <ng-template
        [tuiDialog]="(openPickupTimeSheet$ | async) === true"
        (tuiDialogChange)="openPickupTimeSheet$.next($event)"
    >
        <h2 tuiSheetHeading>{{ t('choose_a_time_to_pick_up') }}</h2>

        <us-select-time-v2
            *ngrxLet="bookingTime$ as bookingTime"
            [min]="now"
            [value]="bookingTime"
            (valueChange)="handleSelectPickupTime($event)"
        ></us-select-time-v2>
    </ng-template>
</ng-container>
